import React from 'react';
import { styled } from '@mui/material/styles';
import { Tooltip, tooltipClasses } from '@mui/material';
import { fontStyle } from '@mui/system';

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }}/>
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#4C5B62',
    color: '#ffffff',
    maxWidth: '339px',
    fontSize: '14px',
    lineHeight: '20px',
    borderRadius: '6px',
    padding: '16px 4px 20px 20px',
    fontWeight: 400,
    fontFamily: 'Source Sans Pro',
    alignSelf: 'stretch',
    fontStyle: 'normal'
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#4C5B62',
    '&:before': {
      backgroundColor: '#4C5B62',
      border: 'none',
    }   
  },
}));

export default CustomTooltip;
